"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRdfStoreOptions.js.map